import Component, { loadComponent } from '../../../assets/scripts/modules/component.js'
import debounce from '../../../assets/scripts/utilities/debounce.js'

class ComparisonTableComponent extends Component {
  init() {
    this.scrollContainer = this.element.querySelector('.comparison-table__scroll-container')
    this.table = this.element.querySelector('.comparison-table__table')
    this.stickyColCells = this.element.querySelectorAll('.comparison-table__sticky-col')
    this.dataColCells = this.element.querySelectorAll('.comparison-table__empty-col--header')

    if (!this.scrollContainer || !this.table || !this.stickyColCells || !this.dataColCells) {
      return
    }

    this.stickyCol = this.stickyColCells[0]
    this.dataCol = this.dataColCells[0]

    if (!this.stickyCol || !this.dataCol) {
      return
    }

    this.dataColWidth = this.dataColCells[0].clientWidth

    if (!this.dataColWidth) {
      return
    }

    this.rowToggles = this.element.querySelectorAll('.comparison-table__row-toggle')
    this.moreCardsLabel = this.element.querySelector('.comparison-table__more-cards-label')

    this.bindEvents()
    this.updateDropShadowVisibility()
    this.updateMoreCardsLabel()
    this.handleArrowKeys()

    //this.debouncedSnapToColumn = debounce(() => this.snapToColumn(), 200)
  }

  bindEvents() {
    const debouncedUpdate = debounce(() => {
      this.updateMoreCardsLabel()
      this.updateDropShadowVisibility()
    }, 200)

    window.addEventListener('resize', debouncedUpdate)
    this.scrollContainer.addEventListener('scroll', () => this.handleTableScroll(), { passive: true })
    this.rowToggles?.forEach(toggle => toggle.addEventListener('toggle', () => this.toggleRows(toggle)))
  }

  updateDropShadowVisibility() {
    const tableIsSmaller = this.table.clientWidth < this.scrollContainer.clientWidth || this.scrollContainer.clientWidth === this.scrollContainer.scrollWidth

    this.scrollContainer.classList.toggle('comparison-table__scroll-container--drop-shadow-right', !tableIsSmaller)
  }

  handleTableScroll() {
    const { scrollLeft, clientWidth, scrollWidth } = this.scrollContainer
    const atStart = scrollLeft === 0
    const atEnd = scrollLeft + clientWidth >= scrollWidth - 10

    this.moreCardsLabel?.classList.toggle('comparison-table__more-cards-label--hidden', atEnd)
    this.scrollContainer.classList.toggle('comparison-table__scroll-container--drop-shadow-left', !atStart)
    this.scrollContainer.classList.toggle('comparison-table__scroll-container--drop-shadow-right', !atEnd)

    //this.debouncedSnapToColumn()
  }

  updateMoreCardsLabel() {
    const tableMarginLeft = parseInt(window.getComputedStyle(this.table).marginLeft, 10)
    const tableWidth = tableMarginLeft < 0 ? this.table.clientWidth - this.stickyCol.clientWidth : this.table.clientWidth
    const isHidden = tableWidth <= this.scrollContainer.clientWidth

    this.moreCardsLabel?.classList.toggle('comparison-table__more-cards-label--hidden', isHidden)
  }

  handleArrowKeys() {
    this.scrollContainer.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault()
      }
    })

    this.scrollContainer.addEventListener('keyup', event => {
      const { scrollLeft } = this.scrollContainer
      const scrollStep = this.calculateScrollStep(scrollLeft)

      if (event.key === 'ArrowRight') {
        this.scrollContainer.scrollLeft += scrollStep
      } else if (event.key === 'ArrowLeft') {
        this.scrollContainer.scrollLeft = Math.max(0, this.scrollContainer.scrollLeft - scrollStep)
      }
    })
  }

  calculateScrollStep(scrollLeft) {
    const remainder = (scrollLeft / this.dataColWidth) % 1

    return remainder < 0.5 ? (1 - remainder) * this.dataColWidth : this.dataColWidth
  }

  snapToColumn() {
    const { scrollLeft } = this.scrollContainer
    const remainder = (scrollLeft / this.dataColWidth) % 1

    if (remainder !== 0) {
      const snapTo = Math.round(scrollLeft / this.dataColWidth)

      this.scrollContainer.scrollLeft = snapTo * this.dataColWidth
    }
  }

  toggleRows(toggle) {
    const summary = toggle.querySelector('summary')
    const rowgroup = summary?.getAttribute('aria-controls') ? document.getElementById(summary.getAttribute('aria-controls')) : null

    if (summary && rowgroup) {
      const isExpanded = summary.getAttribute('aria-expanded') === 'true'

      summary.setAttribute('aria-expanded', !isExpanded)
      rowgroup.setAttribute('aria-hidden', isExpanded)
    }
  }
}

window.addEventListener('init-load', () => loadComponent(document, 'comparison-table', ComparisonTableComponent))
